import script from "./ScreeningCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreeningCreate.vue?vue&type=script&setup=true&lang=js"

import "./ScreeningCreate.vue?vue&type=style&index=0&id=fc9365f6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc9365f6"]])

export default __exports__